import * as React from 'react';

import {
    setHasInvalidCode as setHasInvalidCodeAction,
    setPaymentRequest as setPaymentRequestAction,
    setHasBillingAddress as setHasBillingAddressAction,
    setHasBillingAddressError as setHasBillingAddressErrorAction,
    setBillingAddressDetails as setBillingAddressDetailsAction,
    setTransactionUrl as setTransactionUrlAction
} from './actions';
import { store } from './store';
import { PaymentRequest, BillingAddressDetails } from './types';

export function usePaymentContext() {
    const context = React.useContext(store);

    if (context === undefined)
        throw new Error('usePaymentContext must be used within an PaymentContextProvider');

    const setHasInvalidCode = (hasInvalidCode: boolean) =>
        context.dispatch(setHasInvalidCodeAction(hasInvalidCode));

    const setPaymentRequest = (paymentRequest?: PaymentRequest) =>
        context.dispatch(setPaymentRequestAction(paymentRequest));

    const setBillingAddressDetails = (billingAddress:BillingAddressDetails) =>
        context.dispatch(setBillingAddressDetailsAction(billingAddress));

    const setHasBillingAddress = (isBillingAddressSet: boolean) =>
        context.dispatch(setHasBillingAddressAction(isBillingAddressSet));

    const setHasBillingAddressError = (hasBillingAddressError: boolean) =>
        context.dispatch(setHasBillingAddressErrorAction(hasBillingAddressError));

    const setTransactionUrl = (transactionUrl:string) =>
        context.dispatch(setTransactionUrlAction(transactionUrl));

    return {
        hasInvalidCode: context.state.hasInvalidCode,
        paymentRequest: context.state.paymentRequest,
        isBillingAddressSet: context.state.isBillingAddressSet,
        hasBillingAddressError: context.state.hasBillingAddressError,
        billingAddressDetails: context.state.billingAddressDetails,
        transactionUrl: context.state.transactionUrl,
        setHasInvalidCode,
        setPaymentRequest,
        setHasBillingAddress,
        setHasBillingAddressError,
        setBillingAddressDetails,
        setTransactionUrl
    } as const;
};